export default __webpack_public_path__ + "static/media/LP-L-CW.57965382.jpg";